// extracted by mini-css-extract-plugin
export default {"Tab":"Tab_Tab__a1XRL","Counter":"Tab_Counter__bscrq","Active":"Tab_Active__xor7h","Badge":"Tab_Badge__W9hAy","ForcedBadge":"Tab_ForcedBadge__6Lpi+"};